enum LeadTimeTypeEnum {
    DAYS = "days",
    WEEKS = "weeks",
    MONTHS = "months",
}

export default LeadTimeTypeEnum;
